import AdminLayout from "../../../components/admin/layout/AdminLayout";
import BuyerSingleView from "../../../components/admin/buyer/BuyerSingleView";
import { useLocation } from "react-router-dom";

function BuyerSingleViewPage() {
  const location = useLocation();
  const id = location.state || {};

  return (
    <AdminLayout>
      <BuyerSingleView id={id} />
    </AdminLayout>
  );
}

export default BuyerSingleViewPage;
